import React from 'react'
import classNames from 'classnames'
import { PriceLabel as PraxisPlusLabel, PromoLabel, PROMO_LABEL_CONSTANTS } from 'chemistry'
import { BRICO } from 'common/shopInfo'

const vlpLabels = ['Vaste lage prijs', 'Prix bas permanent']
const promotionLabel = ['Aanbiedingen', 'Promotions', 'Promoties']
const praxisPlusLabel = ['Praxis Plus aanbiedingen', 'Promotions exclusives', 'Exclusieve promoties']

const PromotionLabel = ({ text, format }) => (
  <span className={classNames('mxd-filter-promotion-label', { 'mxd-filter-promotion-label-brico': format === BRICO })}>
    <PraxisPlusLabel text={text} />
  </span>
)

const PraxisPlusPromotionLabel = ({ text, format }) => (
  <span className={classNames({ 'mxd-filter-praxis-plus-label-brico': format === BRICO })}>
    <PraxisPlusLabel text={text} />
  </span>
)

const PromotionFilterValues = ({ label, format, lang }) => {
  if (vlpLabels.includes(label))
    return (
      <PromoLabel
        size={PROMO_LABEL_CONSTANTS.SIZE.small}
        variant={PROMO_LABEL_CONSTANTS.VARIANT.alwaysLowPrice}
        format={format}
        lang={lang}
      />
    )
  if (praxisPlusLabel.includes(label))
    return <PraxisPlusPromotionLabel text={label.split(' aanbiedingen')[0]} format={format} />
  if (promotionLabel.includes(label)) return <PromotionLabel text={label} format={format} />
  return null
}

export default PromotionFilterValues
